
import type { JSX } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TreeView } from '@lexical/react/LexicalTreeView';
import {useState, useEffect} from 'react';
import { COMMAND_PRIORITY_EDITOR, KEY_DOWN_COMMAND } from 'lexical';

export default function TreeViewPlugin(): JSX.Element {
  const [editor] = useLexicalComposerContext();
  const [showTreeViewPlugin, setShowTreeViewPlugin] = useState(false);
  useEffect(() => {
      return editor.registerCommand(
        KEY_DOWN_COMMAND,
        (event) => {
          if(event.ctrlKey && event.shiftKey && event.key === "D") {
            setShowTreeViewPlugin(!showTreeViewPlugin);
            return true
          }
          return false;
        },
       COMMAND_PRIORITY_EDITOR 
      )
  }, [editor, showTreeViewPlugin]);

  if (showTreeViewPlugin) {
    return (
      <TreeView
        viewClassName="tree-view-output"
        treeTypeButtonClassName="debug-treetype-button"
        timeTravelPanelClassName="debug-timetravel-panel"
        timeTravelButtonClassName="debug-timetravel-button"
        timeTravelPanelSliderClassName="debug-timetravel-panel-slider"
        timeTravelPanelButtonClassName="debug-timetravel-panel-button"
        editor={editor}
      />
    );
  } else {
    return <></>
  }
}